export const CloseCircle = ({ stroke="#ffffff", fill = "#ffffff", opacity = 0.2, width = 32, height = 32 }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
    >
      <g clip-path="url(#clip0_3972_3938)">
        <path
          opacity={opacity}
          d="M16 29.334C18.637 29.334 21.2147 28.552 23.4073 27.087C25.5999 25.622 27.3088 23.5398 28.318 21.1035C29.3272 18.6673 29.5913 15.9865 29.0769 13.4002C28.5625 10.8139 27.2928 8.43817 25.4282 6.57347C23.5636 4.70878 21.188 3.43886 18.6017 2.92429C16.0155 2.40972 13.3347 2.67361 10.8984 3.6826C8.46206 4.69159 6.37966 6.40036 4.91449 8.59283C3.44932 10.7853 2.66719 13.363 2.66699 16C2.67728 19.533 4.08527 22.9185 6.58344 25.4168C9.08161 27.9152 12.4669 29.3234 16 29.334Z"
          fill={fill}
        />
        <path
          d="M12.2271 19.774L19.7741 12.227"
          stroke={stroke}
          stroke-width="1.5"
          stroke-linejoin="round"
        />
        <path
          d="M19.7741 19.774L12.2271 12.227"
          stroke={stroke}
          stroke-width="1.5"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3972_3938">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
